/*
https://splidejs.com/guides/getting-started/
*/

import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';

const slider = document.querySelector('.procedures-slider');

if( slider ) {
    var splide = new Splide( slider, {
        type: 'loop',
        rewind: true,
        speed: 1000,
        arrows: true,
        pagination: false,
        perPage: 1,
        perMove: 1,
        height: 'auto',
        autoHeight: true,
        updateOnMove: true,
        // padding: {
        //     right: '15%'
        // },
        gap: '1%',
    });
    splide.mount();
}